/* eslint-disable jsx-a11y/anchor-is-valid */
import {lazy, useEffect} from 'react'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'

import {useThemeMode} from '_metronic/partials'
import {toAbsoluteUrl} from '_metronic/helpers'

const Login = lazy(() => import('./components/Login'))
const ForgotPassword = lazy(() => import('./components/ForgotPassword'))
const ResetPassword = lazy(() => import('./components/ResetPassword'))
const Activation = lazy(() => import('./components/Activation'))

const AuthLayout = () => {
  const {mode} = useThemeMode()
  useEffect(() => {
    document.body.classList.add('bg-body')
    return () => {
      document.body.classList.remove('bg-body')
    }
  }, [])

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
      style={{
        backgroundImage: `url(${toAbsoluteUrl(
          `/media/bg/bg-3${mode === 'light' ? '' : '-dark'}.jpg`
        )})`,
      }}
    >
      {/* begin::Content */}
      <div className='d-flex flex-center flex-column p-8'>
        {/* begin::Logo */}
        <a href='#' className='mb-5'>
          <img
            alt='Logo'
            src={toAbsoluteUrl(
              `/media/orins/orins-corp-logo-login${mode === 'light' ? '' : '-dark'}.png`
            )}
            className='mb-10'
            loading='lazy'
          />
        </a>
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className='w-lg-500px bg-body rounded shadow-sm p-10 mx-auto'>
          <Outlet />
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}

      {/* begin::Footer */}
      {/* end::Footer */}
    </div>
  )
}

const AuthPage = () => (
  <Routes>
    <Route path='*' element={<Navigate to='/auth' />} />
    <Route element={<AuthLayout />}>
      <Route path='/login/*' element={<Login />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='reset-password/:token' element={<ResetPassword />} />
      <Route path='activation/:token' element={<Activation />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
